import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { useThrottle } from '@wix/da-hooks/pkg/useThrottle';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import Plus from '@wix/da-ds/pkg/Icons/Plus';
import Check from '@wix/da-ds/pkg/Icons/Check';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedInAndVerified } from '../utils/hooks/useRestrictToLoggedInAndVerified';
import { ResourceType } from '../types/resource';
import s from './JoinGroupButton.scss';
var JoinGroupButton = function (_a) {
    var _b, _c;
    var group = _a.group, requestJoin = _a.requestJoin, className = _a.className, showAdminButton = _a.showAdminButton, _d = _a.type, type = _d === void 0 ? 'text' : _d;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    // throttle those button presses so there's time for any notifications to disappear/backend requests to complete
    var requestJoinThrottled = useThrottle(function () { return requestJoin(group); }, [requestJoin, group], 6000);
    var _e = useRestrictToLoggedInAndVerified(), isLoggedIn = _e.isLoggedIn, isVerificationNeeded = _e.isVerificationNeeded, restrictToLoggedInAndVerified = _e.restrictToLoggedInAndVerified;
    var loggedInAndVerified = isLoggedIn && !isVerificationNeeded;
    var biData = loggedInAndVerified
        ? {
            evid: BiEventType.JOIN_GROUP,
            groupid: group.useridUuid,
            sectionname: 'button',
        }
        : undefined;
    var onClick = restrictToLoggedInAndVerified(ReferralType.JOIN_GROUP, 'joingroup', requestJoinThrottled);
    if (((_b = group.extendedGroup) === null || _b === void 0 ? void 0 : _b.isAdmin) && showAdminButton) {
        return (React.createElement(GhostButton, { size: "medium", variant: "approval-green", className: className, href: Url.groupNotificationsLink(group.userId), biData: {
                evid: BiEventType.VIEW_GROUP_NOTIFICATION,
                typeid: ResourceType.GROUP,
                itemid: group.userId,
                groupid: group.useridUuid,
                sectionname: 'button',
            } }, t('joinGroupButton.admin')));
    }
    if ((_c = group.extendedGroup) === null || _c === void 0 ? void 0 : _c.isIngroup) {
        return (React.createElement(TextButton, { size: "small", variant: "main", className: className, icon: Check, iconClassName: s['check-icon'], disabled: true, noHorizontalPaddings: false }, t('joinGroupButton.member')));
    }
    if (isMobile) {
        return (React.createElement(SolidButton, { variant: "approval-green", size: "small", className: className, onClick: onClick, biData: biData }, t('joinGroupButton.join')));
    }
    return type === 'text' ? (React.createElement(TextButton, { size: "small", variant: "approval-green", className: classnames(s['join-text-btn'], className), onClick: requestJoinThrottled, icon: Plus, iconClassName: s['plus-icon'], biData: { evid: BiEventType.JOIN_GROUP, groupid: group.useridUuid }, noHorizontalPaddings: false }, t('joinGroupButton.join'))) : (React.createElement(SolidButton, { size: "medium", variant: "approval-green", className: className, onClick: requestJoinThrottled, biData: biData }, t('joinGroupButton.join')));
};
JoinGroupButton.displayName = 'JoinGroupButton';
export default JoinGroupButton;
//# sourceMappingURL=JoinGroupButton.js.map